export type CursorState = {
  current: string | null
  previous: Array<string | null>
}

export function createCursorState(): CursorState {
  return { current: null, previous: [] }
}

export function advanceCursor(
  state: CursorState,
  next: string,
): CursorState {
  return {
    current: next,
    previous: [...state.previous, state.current],
  }
}

export function goBack(state: CursorState): CursorState {
  if (state.previous.length === 0) {
    return state
  }

  return {
    current: state.previous[state.previous.length - 1] ?? null,
    previous: state.previous.slice(0, -1),
  }
}

export function resetCursorState(state?: CursorState): CursorState {
  if (state?.current === null && state.previous.length === 0) {
    return { current: state.current, previous: [] }
  }

  return createCursorState()
}
